var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUxerSimple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.33859 10.0533V9.63879C4.33859 5.42 7.76231 2 11.9857 2C16.209 2 19.6328 5.42 19.6328 9.63879V10.0533M4.33859 10.0533H4.16588C2.39797 10.0533 1 11.5236 1 13.2931C1 15.0627 2.39797 16.5329 4.16588 16.5329H4.37656C4.76297 20.0121 8.0501 23 11.9857 23C15.9212 23 19.2084 20.0121 19.5948 16.5329H19.8341C21.602 16.5329 23 15.0627 23 13.2931C23 11.5236 21.602 10.0533 19.8341 10.0533H19.6328M4.33859 10.0533V16.5329M19.6328 10.0533V16.5329M16.3449 14.8674C17.6823 16.3174 16.835 19 15.0397 19L11.98 15.1515L8.9467 19C7.15939 19 6.32037 16.3249 7.65731 14.8889L9.50061 12.9091L7.92768 11.1732C6.58964 9.69657 7.45261 7 9.26322 7L11.98 10.6848L14.6968 7C16.5201 7 17.3963 9.708 16.058 11.2071L14.5385 12.9091L16.3449 14.8674Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUxerSimple);
export default __webpack_public_path__ + "static/media/uxer_simple.b592ff72560d940e2a76c4cbbe591470.svg";
export { ForwardRef as ReactComponent };